import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useIndustryProfile = () => {
  const navigate = useNavigate();
  const [profileExists, setProfileExists] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/industry/profile`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        // console.log("The industry data is:",data)
        // If profile missing or has_profile is false → redirect
        if (!res.ok || !data || data.has_profile === false) {
          navigate("/marketplace/industry/profile");
          setProfileExists(false);
        } else {
          setProfileExists(true);
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace/industry/profile");
        setProfileExists(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  return profileExists; 
};

export default useIndustryProfile;


